module.exports = __webpack_public_path__ + "img/magnum-club__cart.2cc5da84.png";